module.exports = __webpack_public_path__ + "0fe5287dd8b53474948c45aea7d9f4e2.pdf";